import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from "recharts";
import { ChartContainer, ChartTooltip, ChartTooltipContent, WarnBox, } from "../elements";
import { gasHistogramSelector, useOptimistReportSelector } from "./state";
const chartConfig = {
    x0: {
        label: "Gas",
        color: "var(--chart-1)",
    },
    count: {
        label: "Number of accounts",
    },
};
export const GasChart = ({ selectedTrackId }) => {
    const data = useOptimistReportSelector(state => gasHistogramSelector(state, selectedTrackId));
    if (!data) {
        return _jsx(WarnBox, { children: "No data" });
    }
    return (_jsx(ChartContainer, { config: chartConfig, className: "aspect-auto h-[250px] w-full", children: _jsxs(BarChart, { accessibilityLayer: true, data: data, margin: {
                left: 12,
                right: 12,
            }, children: [_jsx(CartesianGrid, { vertical: false }), _jsx(XAxis, { dataKey: "label", tickLine: false, axisLine: false, tickMargin: 8, minTickGap: 32 }), _jsx(YAxis, {}), _jsx(ChartTooltip, { content: (props) => (_jsx(ChartTooltipContent, { ...props, className: "w-[150px]", nameKey: "count", labelFormatter: (_, p) => {
                            return p[0].payload.tooltip;
                        } })) }), _jsx(Bar, { dataKey: "count", fill: "var(--color-x0)" })] }) }));
};
